import { render } from "./DemoExpiryNotice.vue?vue&type=template&id=1499116d&scoped=true"
import script from "./DemoExpiryNotice.vue?vue&type=script&lang=js"
export * from "./DemoExpiryNotice.vue?vue&type=script&lang=js"

import "./DemoExpiryNotice.vue?vue&type=style&index=0&id=1499116d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1499116d"]])

export default __exports__